// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select--mII0-"};